import { alpha, darken } from '@mui/material/styles';
import palette from '../theme/palette';
import breakpoints from '../theme/breakpoints';
import { BUTTON_BORDER_RADIUS } from '../theme/constants';

// @TODO Do we really need to specify hover: none?
const variants = [
  {
    props: { variant: 'opaque' },
    style: {
      color: palette.primary.main,
      backgroundColor: palette.common.white,
      '&:hover': {
        backgroundColor: alpha(palette.common.white, 1 - (palette.action.hoverOpacity + 0.06)),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  {
    props: { color: 'internal' },
    style: {
      color: palette.internal.main,
      backgroundColor: alpha(palette.internal.main, 0.06),
      '&:hover': {
        backgroundColor: alpha(palette.internal.main, 0.06 + palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  {
    props: { color: 'internal', variant: 'outlined' },
    style: {
      borderColor: palette.internal.main,
      background: 'transparent',
      '&:hover': {
        borderColor: palette.internal.main,
        backgroundColor: alpha(palette.internal.main, palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  {
    props: { color: 'internal', variant: 'contained' },
    style: {
      backgroundColor: palette.internal.main,
      color: palette.common.white,
      '&:hover': {
        backgroundColor: palette.internal.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: palette.internal.main,
        },
      },
    },
  },
  {
    props: { color: 'success' },
    style: {
      color: palette.success.main,
      backgroundColor: alpha(palette.success.main, 0.06),
      '&:hover': {
        backgroundColor: alpha(palette.success.main, 0.06 + palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  {
    props: { color: 'primary', variant: 'outlined' },
    style: {
      borderColor: palette.primary.main,
      '&:hover': {
        borderColor: palette.primary.main,
      },
    },
  },
  {
    props: { color: 'success', variant: 'outlined' },
    style: {
      borderColor: palette.success.main,
      backgroundColor: 'transparent',
      '&:hover': {
        borderColor: palette.success.main,
        backgroundColor: alpha(palette.success.main, palette.action.hoverOpacity),
      },
    },
  },
  {
    props: { color: 'success', variant: 'contained' },
    style: {
      backgroundColor: palette.success.main,
      color: palette.common.white,
      '&:hover': {
        backgroundColor: palette.success.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: palette.success.main,
        },
      },
    },
  },
  {
    props: { color: 'error' },
    style: {
      color: palette.error.main,
      backgroundColor: alpha(palette.error.main, 0.06),
      '&:hover': {
        backgroundColor: alpha(palette.error.main, 0.06 + palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
  },
  {
    props: { color: 'error', variant: 'outlined' },
    style: {
      borderColor: palette.error.main,
      backgroundColor: 'transparent',
      '&:hover': {
        borderColor: palette.error.main,
        backgroundColor: alpha(palette.error.main, palette.action.hoverOpacity),
      },
    },
  },
  {
    props: { color: 'error', variant: 'contained' },
    style: {
      backgroundColor: palette.error.main,
      color: palette.common.white,
      '&:hover': {
        backgroundColor: palette.error.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: palette.error.main,
        },
      },
    },
  },
  {
    props: {
      size: 'uniform',
    },
    style: {
      [`@media only screen and (min-width: ${breakpoints.sm}px)`]: {
        gap: '4px',
        lineHeight: '19px',
        justifyContent: 'start',
      },
      [`@media only screen and (min-width: ${breakpoints.md}px)`]: {
        whiteSpace: 'normal',
      },
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '120px',
      minHeight: '57px',
      height: '100%',
      padding: '8px 8px 8px 8px',
      '& .MuiButton-startIcon': {
        margin: '4px 0px 0px 0px',
        '& + span': {
          flexGrow: 1,
        },
      },
      lineHeight: 1.25,
    },
  },
  // Rebranding
  {
    props: { variant: 'contained' },
    style: {
      borderRadius: BUTTON_BORDER_RADIUS,
    },
  },
  {
    props: { color: 'primary', variant: 'contained' },
    style: {
      '&:hover': {
        backgroundColor: darken(palette.primary.main, 0.3),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: darken(palette.primary.main, 0.3),
        },
      },
    },
  },
  {
    props: { variant: 'dashed' },
    style: {
      border: '1px',
      borderColor: palette.primary.main,
      color: palette.primary.main,
      width: '100%',
      padding: '1rem',
      [`@media only screen and (min-width: ${breakpoints.sm}px)`]: {
        padding: '1.5rem 1rem',
      },
      '&, &:hover': {
        borderStyle: 'dashed',
      },
      '&:hover': {
        background: palette.background.primary,
        cursor: 'pointer',
      },
    },
  },
];

export default variants;
